import { c as _c } from "react-compiler-runtime";
import { useLayoutEffect } from 'react';
import { setWidth } from '../../resizing/redux/widthsSlice';
import { DEFAULT_COLUMN_WIDTH } from '../constants/sizes';
import { getColumnKey } from '../utils/getColumnKey';
import { getCtaMinimumColumnWidthPx } from './getCtaPopoverLayoutWidths';
const DEFAULT_NAMESPACE = 'DEFAULT_NAMESPACE';
export function useAdjustCtaColumnWidth(t0) {
  const $ = _c(5);
  const {
    columnCallToAction,
    columnsWithDefaults,
    widthsStore
  } = t0;
  let t1;
  let t2;
  if ($[0] !== columnCallToAction || $[1] !== columnsWithDefaults || $[2] !== widthsStore) {
    t1 = () => {
      var _ctaColumn$columnName, _widthsStore$getState;
      if (!(columnCallToAction !== null && columnCallToAction !== void 0 && columnCallToAction.columnName)) {
        return;
      }
      const ctaColumn = columnsWithDefaults.find(col => {
        if (col.columnName !== columnCallToAction.columnName) {
          return false;
        }
        if (columnCallToAction.columnNamespace !== undefined) {
          return col.columnNamespace === columnCallToAction.columnNamespace;
        }
        return true;
      });
      if (!ctaColumn) {
        return;
      }
      const resolvedNamespace = (_ctaColumn$columnName = ctaColumn.columnNamespace) !== null && _ctaColumn$columnName !== void 0 ? _ctaColumn$columnName : DEFAULT_NAMESPACE;
      const columnKey = getColumnKey(resolvedNamespace, ctaColumn.columnName);
      const currentWidth = (_widthsStore$getState = widthsStore.getState().widths.widths[columnKey]) !== null && _widthsStore$getState !== void 0 ? _widthsStore$getState : DEFAULT_COLUMN_WIDTH;
      const minimumWidth = getCtaMinimumColumnWidthPx(columnCallToAction);
      if (currentWidth < minimumWidth) {
        widthsStore.dispatch(setWidth({
          columnKey,
          width: minimumWidth
        }));
      }
    };
    t2 = [columnCallToAction, columnsWithDefaults, widthsStore];
    $[0] = columnCallToAction;
    $[1] = columnsWithDefaults;
    $[2] = widthsStore;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useLayoutEffect(t1, t2);
}